import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles, theme } from "../theme";

interface BWThemeProviderProps {
    children: React.ReactNode;
}

const BWThemeProvider: React.FC<BWThemeProviderProps> = ({ children }) => (
    <ThemeProvider theme={theme}>
        <GlobalStyles />
        {children}
    </ThemeProvider>
);

export default BWThemeProvider;
